module.exports = __webpack_public_path__ + "static/media/th-list.95eb2d8f.svg";